import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/iceland/400.css';
import '@fontsource/vast-shadow/400.css';
import App from './App';
import { registerServiceWorker } from './registerServiceWorker';
import './styles.css';

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
